export const platformAudiences = [
    {
        id: "consignor",
        labelKey: "main.landing.capabilities.audiences.consignor.label",
        eyebrowKey: "main.landing.capabilities.audiences.consignor.eyebrow",
        titleKey: "main.landing.capabilities.audiences.consignor.title",
        descriptionKey: "main.landing.capabilities.audiences.consignor.description",
        actionKey: "main.landing.capabilities.trialAction",
        secondaryAction: {
            href: "#tariffs",
            labelKey: "main.landing.capabilities.tariffsAction",
        },
        featureKeys: [
            "main.landing.capabilities.audiences.consignor.features.bidding",
            "main.landing.capabilities.audiences.consignor.features.documents",
            "main.landing.capabilities.audiences.consignor.features.control",
        ],
    },
    {
        id: "forwarder",
        labelKey: "main.landing.capabilities.audiences.forwarder.label",
        eyebrowKey: "main.landing.capabilities.audiences.forwarder.eyebrow",
        titleKey: "main.landing.capabilities.audiences.forwarder.title",
        descriptionKey: "main.landing.capabilities.audiences.forwarder.description",
        actionKey: "main.landing.capabilities.trialAction",
        secondaryAction: {
            href: "#tariffs",
            labelKey: "main.landing.capabilities.tariffsAction",
        },
        featureKeys: [
            "main.landing.capabilities.audiences.forwarder.features.multiAccount",
            "main.landing.capabilities.audiences.forwarder.features.basicPlan",
            "main.landing.capabilities.audiences.forwarder.features.gosLog",
        ],
    },
    {
        id: "carrier",
        labelKey: "main.landing.capabilities.audiences.carrier.label",
        eyebrowKey: "main.landing.capabilities.audiences.carrier.eyebrow",
        titleKey: "main.landing.capabilities.audiences.carrier.title",
        descriptionKey: "main.landing.capabilities.audiences.carrier.description",
        actionKey: "main.landing.capabilities.carrierAction",
        secondaryAction: {
            href: "/deliveries/dashboard-deliveries",
            labelKey:
                "main.landing.capabilities.availableDeliveriesAction",
        },
        featureKeys: [
            "main.landing.capabilities.audiences.carrier.features.offers",
            "main.landing.capabilities.audiences.carrier.features.management",
            "main.landing.capabilities.audiences.carrier.features.documents",
        ],
    },
];
